import React, { memo } from 'react';

const GoalsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M29.12 0h-3.52c-1.44 0-3.2 1.6-3.2 3.2h-12.8c0-1.6-1.76-3.2-3.2-3.2h-6.4v14.4c0 1.6 1.6 3.2 3.2 3.2h3.52c0.64 3.2 2.72 5.92 7.68 6.4v3.36c-3.52 0.32-4.8 2.080-4.8 4.16v0.48h12.8v-0.48c0-2.080-1.28-3.84-4.8-4.16v-3.36c4.96-0.48 7.040-3.2 7.68-6.4h3.52c1.6 0 3.2-1.6 3.2-3.2v-14.4h-2.88zM3.2 14.4v-11.2h3.2v11.2c-1.44 0-2.72 0-3.2 0zM28.8 14.4c-0.48 0-1.76 0-3.2 0v-11.2h3.2v11.2z"
        />
    </svg>
);

export default memo(GoalsIcon);
